import { COMPANION_AETHLING } from "odyssey-shared";

/**
 * The numbers of a companion's follow and the sheets he is drawn with (ADR-142 decision 7.2). Distances are in tiles and
 * speeds in tiles a second, so they hold at any tile size; they are provisional until the author has judged the look.
 */

/**
 * How far behind his player on the player's trail he follows, in tiles.
 */
export const TRAIL_LAG_TILES = 1;

/**
 * The gap, in tiles, under which he may land once his player has stopped or stopped running and he has arrived.
 */
export const LAND_GAP_TILES = 2;

/**
 * How far from his player's feet he waits when the player stands still, in tiles.
 */
export const REST_DISTANCE_TILES = 0.9;

/**
 * How long, in ms, a player stands still before he goes to wait beside them.
 */
export const REST_DELAY_MS = 180;

/**
 * The fastest he hops, in tiles a second: a little over a walking player, so he keeps up on his short legs.
 */
export const HOP_SPEED_TILES = 5;

/**
 * The fastest he flies, in tiles a second: well over a running player.
 */
export const FLY_SPEED_TILES = 11;

/**
 * How hard he closes a gap: his speed is the gap times this, per second, up to his fastest.
 */
export const CLOSING_RATE = 7;

/**
 * The distance from his goal, in tiles, past which he starts to move, and under which he stops (so he does not shuffle).
 */
export const START_MOVING_TILES = 0.3;
export const STOP_MOVING_TILES = 0.08;

/**
 * A jump of this many tiles in one frame is a teleport: the trail he follows starts again from where the player now stands.
 */
export const TELEPORT_TILES = 6;

/**
 * Most ms of one frame the follow integrates, so a stalled tab does not carry him across the map in one step.
 */
export const MAX_STEP_MS = 100;

/**
 * Points the trail keeps; spaced a quarter tile apart this reaches back past the lag by a wide margin.
 */
export const TRAIL_POINTS = 48;

/**
 * Trail points are laid a quarter tile apart.
 */
export const TRAIL_SPACING_TILES = 0.25;

/**
 * How a companion is drawn: the character sheet the manifest holds and the exact scale it is drawn at.
 */
export interface CompanionLook {
  readonly sheet: string;
  readonly scale: number;
}

/**
 * The look of each companion id (ADR-142 decision 7.1): the Aethling, a half-size figure on his own sheet.
 */
export const COMPANION_LOOKS: ReadonlyMap<number, CompanionLook> = new Map([[COMPANION_AETHLING, { sheet: "aethling", scale: 0.5 }]]);
